import { throttled, debounced } from '../../../lib/functions';

const GRAY = '#4a4a4a';
const LIGHT_GRAY = '#87888a';
const PRIMARY = '#0D9C83';
const DANGER = '#9c290d';
const WARNING = '#cfa51b';

const PRIMARY_OP = '#F2637C';
const DANGER_OP = '#63D6F2';
const WARNING_OP = '#305AE4';

export default {
  data() {
    return {
      primaryColor: PRIMARY,
      warningColor: WARNING,
      dangerColor: DANGER,
      grayColor: GRAY,
      confirmationPromise: null,
      colorScale: [LIGHT_GRAY, PRIMARY, WARNING, DANGER],
      acrColorMappings: [
        [0, 0.8],
        [0.8, 1.3],
        [1.3, 1.5],
        [1.5, null],
      ],
    };
  },
  computed: {
    loggedInMemberId() {
      return this.$store.state.user.memberId;
    },
  },
  methods: {
    platform() {
      return window.platform ? window.platform.toLowerCase() : null;
    },
    portrait() {
      return window.matchMedia('(orientation: portrait)').matches;
    },
    landscape() {
      return window.matchMedia('(orientation: landscape)').matches;
    },
    colorFromAcr(acr) {
      let ret;
      this.acrColorMappings.forEach((v, i) => {
        if ((v[0] === null || v[0] <= acr) && (v[1] === null || acr < v[1])) {
          ret = i;
          return false;
        }
        return true;
      });
      return ret;
    },
    colorFromGct(gct) {
      if (gct < 250) {
        return 1;
      }
      if (gct >= 250 && gct <= 300) {
        return 2;
      }
      if (gct > 300) {
        return 3;
      }
      return 0;
    },
    confirmation(config) {
      return new Promise((resolve, reject) => {
        this.confirmationPromise = {
          resolve,
          reject,
        };
        this.$container.eventBus.emit(
          'toggleConfirmation',
          Object.assign({}, config || {}, { promise: this.confirmationPromise }),
        );
      });
    },
    alert(config) {
      this.$container.eventBus.emit('toggleAlert', Object.assign({}, config || {}));
    },
    wait(config) {
      this.$container.eventBus.emit('toggleWait', Object.assign({
        open: true,
      }, config));
    },
    stopWaiting() {
      this.$container.eventBus.emit('toggleWait', { open: false });
    },
  },
};
